export default {"src":"/_next/static/media/nunchaku.b492548e.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};